const fetchProductDetails = async (productUrl) => {
  const sectionUrl = `${productUrl}?section_id=card-product`;
  try {
    const response = await fetch(sectionUrl);
    const text = await response.text();
    const item = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-card-product');
    return item ? item.innerHTML : '';
  } catch (error) {
    console.error('Error fetching product details:', error);
    return '';
  }
};

const getRecentPdp = async () => {
  const storedData = localStorage.getItem('recently_viewed_items');
  const pdpData = storedData ? JSON.parse(storedData) : [];

  if (!pdpData.length) {
    document.querySelector('.section-recently-viewed-product')?.remove();
    return;
  }

  const productListHTML = await Promise.all(
    pdpData.map(async (item) => {
      const productDetails = await fetchProductDetails(item.productUrl);
      return productDetails;
    })
  );

  const productListContainer = document.querySelector('.recently-viewed-products');
  if (productListContainer) productListContainer.innerHTML = productListHTML.reverse().join('');

  const elmSwiper = document.querySelector('.swiper-recently');
  new Swiper(elmSwiper, {
    slidesPerView: 2.3,
    spaceBetween: 15,
    breakpoints: {
      990: {
        slidesPerView: 6.1,
        spaceBetween: 28,
      },
      750: {
        slidesPerView: 4.1,
        spaceBetween: 21,
      },
      390: {
        slidesPerView: 2.3,
        spaceBetween: 15,
      },
    },
  });
  document.querySelector('.section-recently-viewed-product').classList.add('loaded');
};
document.addEventListener('DOMContentLoaded', () => getRecentPdp());
